export const en = {
    Upload: "Upload",
    ClickToUpload: "Click or drag file to this area to upload"

}